import React from 'react';

const Nigeria1 = () => {
  return (
    <div>
      
    </div>
  );
}

export default Nigeria1;
